__turbopack_context__.v({
  "className": "open_sans_8b81b886-module__Zc-lzW__className",
});
